<template>
	<mc-container :title="title" :tips="currentTips" class="mc-checkbox-group">
		<slot></slot>
	</mc-container>
</template>
<script type="text/ecmascript-6">
    import Validator from '../mixins/validator';
    import { findComponentsDownward, oneOf } from '../lib/assist';

    export default {
        name: 'CheckboxGroup',
        mixins: [ Validator],
        props: {
            value: {
                type: Array,
                default () {
                    return [];
                }
            },
            title: {
                type: String,
                description: '组件标题'
            },
            size: {
                validator (value) {
                    return oneOf(value, ['small', 'large', 'default']);
                }
            },
            validateEvent: {
                type: Boolean,
                default: true
            },
            rules: {
                type: [Object, Array]
            }
        },
        data () {
            return {
                currentValue: this.value,
	            currentTips: '',
                childrens: []
            };
        },
        computed: {
        },
        mounted () {
            this.updateModel(true);
        },
        methods: {
            updateModel (update) {
                this.childrens = findComponentsDownward(this, 'Checkbox');
                if (this.childrens) {
                    const { value } = this;
                    this.childrens.forEach(child => {
                        child.model = value;

                        if (update) {
                            child.currentValue = value.indexOf(child.label) >= 0;
                            child.group = true;
                        }
                    });
                }
            },
            change (data) {
                this.currentValue = data;
                this.$emit('input', data);
                this.$emit('change', data);
                this.validate('change', data);
            }
        },
        watch: {
            value (val) {
                this.updateModel(true);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/base-checkbox-group.vue